const minimumNativeVersion_iOS = 15; // TODO: change to 999 for testing, 15 for prod
const eventRecentPeriodInHours = 24;

export {
    minimumNativeVersion_iOS,
    eventRecentPeriodInHours,
}



// WEBPACK FOOTER //
// ./src/globals.js